import { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import AppRoutes from './routes';
import { APP_CONFIG } from './config/app';
import FreelancerAvailability from './pages/FreelancerAvailability';
import PrivateRoute from './components/PrivateRoute';
import { APIProvider } from '@vis.gl/react-google-maps';

function App() {
  useEffect(() => {
    // Update page title
    document.title = APP_CONFIG.title;

    // Update favicon dynamically for better branding
    const link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
    if (link) {
      link.href = APP_CONFIG.favicon;
    }
  }, []);

  return (
    <APIProvider apiKey={APP_CONFIG.googleMapsApiKey} libraries={['marker', 'places']}>
    <AuthProvider>
      <Toaster
        position="top-center"
        toastOptions={{
          className: 'bg-[#2F3136] text-gray-100 border border-gray-600',
          duration: 4500,
        }}
      />
      <Router>
        <Routes>
          <Route path="/*" element={<AppRoutes />} />
          <Route
            path="/freelancer/availability"
            element={
              <PrivateRoute>
                <FreelancerAvailability />
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
    </APIProvider>
  );
}

export default App;